import { environment } from '~env/environment';
import {ApiConfig} from '~shared/constants';

export const COUNTRY_CODE_HEADER_WHITELIST_URLS = () => [
  environment.svcUserAccountBaseUrl(),
  environment.svcBuyerAccountBaseUrl(),
  environment.svcCheckoutBaseUrl(),
  environment.getSvcStorefrontBaseUrl(),
  environment.svcProductIndex(),
  environment.svcProductDetail(),
  environment.svcSearch2BaseUrl(),
  environment.svcOrderManagementBaseUrl(),
  environment.svcBuyerCategories(),
  environment.serviceBuyerGatewayBaseUrl(),
  environment.multiMarketsCentral(),
  ApiConfig.BUYER_REACT_CART_CONSENT_URL(),
  ApiConfig.BUYER_REACT_ORDER_REVIEW_URL(),
  ApiConfig.SVC_APP_CART_URL_API_ENDPOINT(),
];
